
export type GamepadAxisOOB = 'min' | 'max' | 'minmax' | 'asis';

export type GamepadAxis = {
    type: 'axis';
    index: number;
    valueRange: [number, number]; // [min, max]
    outOfBounds: GamepadAxisOOB; // OOB values are treated as
}

export type GamepadButton = {
    type: 'button';
    index: number;
}

export type GamepadAnd = {
    type: 'and';
    actions: GamepadAction[];
}

export type GamepadOr = {
    type: 'or';
    actions: GamepadAction[];
}

export type GamepadNot = {
    type: 'not';
    action: GamepadAction;
}

export type GamepadAction = GamepadAxis | GamepadButton | GamepadAnd | GamepadOr | GamepadNot;

export function axis(index: number, valueRange: [number, number], outOfBounds: GamepadAxisOOB = 'minmax'): GamepadAxis {
    return { type: 'axis', index, valueRange, outOfBounds };
}

export function button(index: number): GamepadButton {
    return { type: 'button', index };
}

export function and(...actions: GamepadAction[]): GamepadAnd {
    return { type: 'and', actions };
}

export function or(...actions: GamepadAction[]): GamepadOr {
    return { type: 'or', actions };
}

export function not(action: GamepadAction): GamepadNot {
    return { type: 'not', action };
}
